import TopNav from 'components/TopNav';
import React from 'react';
import styles from './style.module.scss';
import { Link, useHistory } from 'react-router-dom';
import { textFooterEnv } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-use';



const PreRegisterJobTrial = () => {
  const { id } = useParams();
  const envInfoList = useSelector((state) => state.envInfo.data);
  const location = useLocation()
  const history = useHistory();

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  const handleRedirect = () =>{
    history.push({
      pathname: `${process.env.RAZZLE_PUBLIC_URL}/register-job`,
      state: { prevPath: location?.state?.state?.prevPath}
    });
  }

  return (
    <div
      style={{
        overflow: 'auto',
        height: '100vh',
        backgroundColor: 'var(--white)',
        maxWidth: 560,
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TopNav name={'仕事応募案内'} hasBackIcon={true} />
      <React.Fragment>
        <div className={styles.wrapperMain}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} className={styles.wrapperBtn}>
            <Link
              style={{
                textDecoration: 'unset',
                color: 'var(--white)',
              }}
              to={`${process.env.RAZZLE_PUBLIC_URL}/register-job`}
              className="btn-main btn-submit"
            >
              <span style={{ marginBottom: 0 }}>登録に進む</span>
            </Link>
          </div>
        </div>
      </React.Fragment>
      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        <p style={{ color: 'var(--text3)' }} className="font-3" dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
      </div>
    </div>
  );
};

export default PreRegisterJobTrial;
